/** @returns {'simple' | 'compound'} */
export function resolvePlanInterestType(plan) {
  const stored = String(plan?.interestType || '').toLowerCase();
  if (stored === 'compound' || stored === 'simple') return stored;
  if (/compound/i.test(String(plan?.interestRate || ''))) return 'compound';
  return 'simple';
}

export function isCompoundPlan(plan) {
  if (!plan || typeof plan !== 'object') return false;
  if (plan.interestKind === 'compound') return true;
  return resolvePlanInterestType(plan) === 'compound';
}

/** @returns {'simple' | 'compound'} */
export function normalizePlanInterestType(raw) {
  const t = String(raw || '').toLowerCase();
  return t === 'compound' ? 'compound' : 'simple';
}

export const PLAN_INTEREST_TYPE_OPTIONS = [
  { value: 'simple', label: 'Simple Interest' },
  { value: 'compound', label: 'Compound Interest' },
];
